const setTriggerText = (el, status) => {
	// Work out new status prompt based on current zoomed status
	const attrType = status === "false" ? "increase" : "decrease";

	// Get text from relevant attr and update trigger text
	const text = el.getAttribute("data-toggle-text-size-" + attrType + "-text");
	el.querySelector("[data-toggle-text-size-text-container]").innerHTML = text;

	// Hide icons
	for (const icon of el.querySelectorAll("span[data-toggle-text-size-icon]")) {
		icon.classList.add("hidden");
	}

	// Show relevant icon
	const attr = "[data-toggle-text-size-" + attrType + "-icon]";
	el.querySelector(attr).classList.remove("hidden");
};

const setBodyZoom = (status) => {
	document.body.style.zoom = status === "false" ? "100%" : "125%";
};

export default () => {
	const itemName = "zoomed";
	let status =
		localStorage.getItem(itemName) === null
			? "false"
			: localStorage.getItem(itemName);

	setBodyZoom(status);

	// Loop through all text size toggle triggers...
	for (const trigger of document.querySelectorAll("[data-toggle-text-size]")) {
		setTriggerText(trigger, status);

		// Update local storage value on click
		trigger.addEventListener("click", () => {
			status = status === "false" ? "true" : "false";
			localStorage.setItem(itemName, status);
			setTriggerText(trigger, status);
			setBodyZoom(status);
		});
	}
};
